namespace Areas.Projects {
    "use strict";

    export function showSharePointProjectLookup() {
        const sharePointProjectLookupDialog =
            new Areas.Dialogs.SharePointProjectLookup.SharePointProjectLookupDialog(sharePointProjectLookupDialogClosing);
    }

    function sharePointProjectLookupDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataId = data.subAccountId;
        const newName = data.plantAccountName;
        const newNumber = data.plantAccountNumber;
        const newPM = data.projectManager;
        const newPMEmail = data.projectManagerEmail;
        const spLoc = data.sharePointProjectLink;
        const desc = data.plantAccountDescription;

        //this is the lookup form _ProjectLookupForm
        const lookupForm: DevExpress.ui.dxForm = Areas.getForm("ProjectLookupForm");
        const lookupData: any = lookupForm.option('formData');

        lookupData.ProjectNumber = newNumber;
        lookupData.ProjectManagerName = newPM;
        lookupData.ProjectManagerEmail = newPMEmail;

        lookupForm.option('formData', lookupData);

        //this is the main form _DataForm.cshtml
        const dataForm: DevExpress.ui.dxForm = Areas.getForm("ProjectsForm");
        const newData: any = dataForm.option('formData');

        newData.ProjectName = newName;
        newData.ProjectNumber = newNumber;
        newData.ProjectManagerName = newPM;
        newData.ProjectManagerEmail = newPMEmail;
        newData.SharePointLocation = spLoc;
        newData.Description = desc;
        newData.SubAccountId = dataId;

        dataForm.option('formData', newData);
    }

}